/**Creating New Announcement functionality is there in this component */

import React, { useState, useEffect } from 'react';
import { alertsaveapi, getbarches, getcategories, getsubcategories, getThemeURL, getallBanksByRole } from '../../../../Services/EndPoints';
import { getData, postDataWithBody } from '../../../../Services/Services';
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import { format, parse, parseISO } from "date-fns";
import './NewAnnouncementsForm.css'
import { Editor } from 'react-draft-wysiwyg';
import { EditorState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'

const AlertModal = ({ show, onClose, onSuccess }) => {
    // Initial empty state
    const initialFormState = {
        title: '',
        remarks: '',
        activeDate: '',
        expiryDate: '',
    };

    const [category, setCategory] = useState('');
    const [subCategory, setSubCategory] = useState([]);
    const [selectedSub, setSelectedSub] = useState('');
    const [banks, setBanks] = useState([]);
    const [selectedBank, setSelectedBank] = useState("");
    const [categories, setCategories] = useState([]);
    const [branch, setBranch] = useState([])
    const [branchvalue, setbranchvalue] = useState('');
    const [validationErrors, setValidationErrors] = useState({});
    const [userId, setUserId] = useState(null);
    const [formData, setFormData] = useState(initialFormState);
    const [editorState, setEditorState] = useState('')

    // Reset form function to clear all form fields
    const resetForm = () => {
        setCategory('');
        setSelectedSub('');
        setSelectedBank('');
        setbranchvalue('');
        setFormData(initialFormState);
        setValidationErrors({});
        setEditorState(EditorState.createEmpty());
    };

    // Fetch data when component mounts
    useEffect(() => {
        fetchuerProfile();
        fetchcategory();
        getUserProfile();
    }, []);

    // Reset form when modal is shown (added this effect)
    useEffect(() => {
        if (show) {
            // No need to reset here, as it might interrupt user input
        } else {
            // Reset when modal closes
            resetForm();
        }
    }, [show]);

    const fetchuerProfile = async () => {
        try {
            const response = await getData(getThemeURL);
            if (response && Array.isArray(response) && response.length > 0) {
                setUserId(response[0].id);
            }
        } catch (error) {
            console.error("Error fetching user profile:", error);
        }
    }

    const fetchcategory = async () => {
        try {
            const response = await getData(getcategories);
            if (response && Array.isArray(response)) {
                setCategories(response);
            } else {
                toast.error("Failed to load categories data");
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const getUserProfile = async () => {
        try {
            const userProfile = await getData(getThemeURL);
            if (userProfile && userProfile.length > 0) {
                fetchBanks(userProfile[0]);
            }
        } catch (error) {
            console.error("Error fetching user profile:", error);
            toast.error("Failed to fetch user profile", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
            });
        }
    };

    const createPayload = (profile) => {
        let admin_role = "U"; // default value

        if (profile.role_name === "HO") {
            admin_role = "HO";
        } else if (profile.role_name === "SUPER ADMIN") {
            admin_role = "SA";
        }

        return {
            admin_role: admin_role,
            bank_id: profile.bank_id || null,
            branch_id: profile.branch_id || null
        };
    };

    const fetchBanks = async (profile) => {
        try {
            const payload = createPayload(profile);
            const response = await postDataWithBody(getallBanksByRole, payload, {});
            if (response && Array.isArray(response)) {
                setBanks(response);
            } else {
                toast.error("Failed to load banks data");
            }
        } catch (error) {
            console.error("Error fetching banks:", error);
        }
    }

    //to handle editor for description
    const onEditorStateChange = (editorState) => {
        setEditorState(editorState);
        const html = editorState.getCurrentContent().getPlainText().trim();
        setFormData(prev => ({ ...prev, remarks: html }));

        // Clear error if user types something
        if (editorState.getCurrentContent().hasText()) {
            setValidationErrors(prev => ({ ...prev, remarks: "" }));
        }
    };

    //handle sub category
    const handleCategoryChange = async (e) => {
        const selected = e.target.value;
        setCategory(selected);
        setSelectedSub(''); // Reset sub-category when category changes

        if (selected) {
            try {
                const response = await getData(getsubcategories
                    .replace("NAME", selected)
                )
                setSubCategory(response);
            } catch (error) {
                console.error("Failed to fetch subcategories:", error);
                setSubCategory([]);
            }
        } else {
            setSubCategory([]);
        }

        if (validationErrors.category) {
            setValidationErrors({
                ...validationErrors,
                category: undefined
            });
        }
    };

    //To handle categories multi select
    const handleMultiSelectChange = async (e) => {
        const bankId = e.target.value;
        setSelectedBank(bankId);
        setbranchvalue(''); // Reset branch when bank changes

        if (validationErrors.selectedBank) {
            setValidationErrors({
                ...validationErrors,
                selectedBank: undefined
            });
        }

        if (bankId) {
            try {
                const response = await getData(getbarches
                    .replace('ID', bankId)
                );
                setBranch(response);
            } catch (error) {
                console.error("Error fetching branches:", error);
                setBranch([]);
            }
        } else {
            setBranch([]);
        }
    };

    //when select branch from category section
    const handlebranceChange = (e) => {
        setbranchvalue(e.target.value);
        if (validationErrors.branchvalue) {
            setValidationErrors({
                ...validationErrors,
                branchvalue: undefined
            });
        }
    }

    const saveApialert = async () => {
        try {
            let input = {
                title: formData.title,
                description: formData.remarks,
                categoryName: category,
                subCategoryName: selectedSub,
                bankId: selectedBank,
                branchId: branchvalue,
                activeDate: format(parse(formData.activeDate, "dd/MM/yyyy", new Date()), "yyyy-MM-dd"),
                expiryDate: format(parse(formData.expiryDate, "dd/MM/yyyy", new Date()), "yyyy-MM-dd"),
                remarks: formData.remarks,
                is_deleted: false,
                created_by: userId
            }

            const response = await postDataWithBody(alertsaveapi, input, {})
            if (response.status === 'success') {
                toast.success(response.msg, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                });

                // Reset form after successful submission
                resetForm();

                // Call onSuccess if provided to trigger parent data refresh
                if (onSuccess && typeof onSuccess === 'function') {
                    onSuccess();
                }

                onClose();
            } else {
                toast.error(response.msg, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error("Error saving alert:", error);
            toast.error("Failed to save alert", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
            });
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const errors = {};

        // Check required fields
        if (!formData.title.trim()) errors.title = "Title is required";
        if (!formData.remarks.trim()) errors.remarks = "Description is required";
        if (!category) errors.category = "Category is required";
        if (!selectedSub) errors.selectedSub = "Sub Category is required";
        if (!selectedBank) errors.selectedBank = "Bank is required";
        if (!branchvalue) errors.branchvalue = "Branch is required";
        if (!formData.activeDate) errors.activeDate = "Active Date is required";
        if (!formData.expiryDate) errors.expiryDate = "Expiry Date is required";

        // Check if dates are valid
        if (formData.activeDate && formData.expiryDate) {
            const active = parse(formData.activeDate, "dd/MM/yyyy", new Date());
            const expiry = parse(formData.expiryDate, "dd/MM/yyyy", new Date());

            if (active > expiry) {
                errors.expiryDate = "Expiry date must be after active date";
            }
        }

        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);
            return;
        }

        // Clear any previous errors
        setValidationErrors({});
        saveApialert();
    };

    const handleClose = () => {
        resetForm();
        onClose();
    };


    if (!show) return null;

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center',
            zIndex: 1000
        }}>
            <div style={{
                backgroundColor: '#fff',
                borderRadius: '10px',
                width: '90%', // Changed from 600px to 90% for wider modal
                maxWidth: '1200px', // Added max-width for very large screens
                maxHeight: '90vh',
                overflowX: 'hidden'
            }}>
                <div style={{
                    backgroundColor: '#fff',
                    padding: '30px',
                    borderRadius: '10px',
                    width: '100%',
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    fontFamily: 'Poppins',
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                        <h3 style={{ margin: 0 }}>New Announcement</h3>
                        <button
                            onClick={handleClose}
                            style={{
                                background: 'gray',
                                border: 'none',
                                width: '30px',
                                height: '30px',
                                fontSize: '20px',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                lineHeight: '1',
                                borderRadius: '50%',
                                color: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: 0
                            }}
                            aria-label="Close"
                        >
                            &times;
                        </button>
                    </div>

                    {/* title and description */}
                    <label>Title<span style={{ color: 'red' }}>*</span></label>
                    <input type="text" className={`form-control mb-2 ${validationErrors.title ? "is-invalid" : ""}`} value={formData.title} onChange={e => {
                        const inputValue = e.target.value;
                        const filteredValue = inputValue.replace(/[^a-zA-Z0-9 ]/g, '');
                        setFormData({ ...formData, title: filteredValue })
                        if (validationErrors.title) {
                            setValidationErrors({
                                ...validationErrors,
                                title: undefined
                            });
                        }
                    }} />
                    {validationErrors.title && <div className="invalid-feedback">{validationErrors.title}</div>}

                    <div className="row mb-3">
                        <div className="col-md-12">
                            <label htmlFor="description" className="form-label">
                                Description<span className="text-danger">*</span>
                            </label>
                            <div className={`border rounded ${validationErrors.description ? "border-danger" : ""}`}>
                                <Editor
                                    editorState={editorState}
                                    wrapperClassName="demo-wrapper"
                                    editorClassName="demo-editor"
                                    onEditorStateChange={onEditorStateChange}
                                    toolbar={{
                                        options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'colorPicker', 'link', 'emoji', 'history'],
                                        inline: {
                                            options: ['bold', 'italic', 'underline', 'strikethrough'],
                                        },
                                    }}
                                    editorStyle={{ minHeight: '150px', padding: '0 10px' }}
                                />
                            </div>
                            {validationErrors.remarks && (
                                <div className="text-danger small">
                                    {validationErrors.remarks}
                                </div>
                            )}
                        </div>
                    </div>
                    {/*  Date Fields*/}
                    <div className="row mb-3">
                        {/* Active Date */}
                        <div className="col-md-6">
                            <label>Active Date <span style={{ color: 'red' }}>*</span></label>
                            <input
                                type="date"
                                className={`form-control ${validationErrors.activeDate ? "is-invalid" : ""}`}
                                style={{ width: '100%', height: '38px', paddingBottom: '24px' }}
                                value={
                                    formData.activeDate
                                        ? format(parse(formData.activeDate, "dd/MM/yyyy", new Date()), "yyyy-MM-dd")
                                        : ""
                                }
                                onChange={(e) => {
                                    if (e.target.value) {
                                        const date = parseISO(e.target.value);
                                        const formatted = format(date, "dd/MM/yyyy");
                                        setFormData({ ...formData, activeDate: formatted });

                                        if (validationErrors.activeDate) {
                                            setValidationErrors({
                                                ...validationErrors,
                                                activeDate: undefined,
                                            });
                                        }
                                    } else {
                                        setFormData({ ...formData, activeDate: "" });
                                    }
                                }}
                            />
                            {validationErrors.activeDate && (
                                <div className="invalid-feedback">{validationErrors.activeDate}</div>
                            )}
                        </div>

                        {/* Expiry Date */}
                        <div className="col-md-6">
                            <label>Expiry Date <span style={{ color: 'red' }}>*</span></label>
                            <input
                                type="date"
                                className={`form-control ${validationErrors.expiryDate ? "is-invalid" : ""}`}
                                style={{ width: '100%', height: '38px', paddingBottom: '24px' }}
                                value={
                                    formData.expiryDate
                                        ? format(parse(formData.expiryDate, "dd/MM/yyyy", new Date()), "yyyy-MM-dd")
                                        : ""
                                }
                                onChange={(e) => {
                                    if (e.target.value) {
                                        const date = parseISO(e.target.value);
                                        const formatted = format(date, "dd/MM/yyyy");
                                        setFormData({ ...formData, expiryDate: formatted });

                                        if (validationErrors.expiryDate) {
                                            setValidationErrors({
                                                ...validationErrors,
                                                expiryDate: undefined,
                                            });
                                        }
                                    } else {
                                        setFormData({ ...formData, expiryDate: "" });
                                    }
                                }}
                            />
                            {validationErrors.expiryDate && (
                                <div className="invalid-feedback">{validationErrors.expiryDate}</div>
                            )}
                        </div>
                    </div>

                    {/* Category and Sub Category */}
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label>Category<span style={{ color: 'red' }}>*</span></label>
                            <select className={`form-control ${validationErrors.category ? "is-invalid" : ""}`} value={category} onChange={handleCategoryChange}>
                                <option value="">Select Category</option>
                                {categories.map((cat, idx) => (
                                    <option key={idx} value={cat}>
                                        {cat}
                                    </option>
                                ))}
                            </select>
                            {validationErrors.category && <div className="invalid-feedback">{validationErrors.category}</div>}
                        </div>
                        <div className="col-md-6">
                            <label>Sub Category<span style={{ color: 'red' }}>*</span></label>
                            <select className={`form-control ${validationErrors.selectedSub ? "is-invalid" : ""}`}
                                value={selectedSub}
                                disabled={!category}
                                onChange={e => {
                                    setSelectedSub(e.target.value)
                                    if (validationErrors.selectedSub) {
                                        setValidationErrors({
                                            ...validationErrors,
                                            selectedSub: undefined
                                        });
                                    }
                                }}>
                                <option value="">Select Sub Category</option>
                                {subCategory.map((sub, i) => (
                                    <option key={i} value={sub.subCategory}>
                                        {sub.subCategory}
                                    </option>
                                ))}
                            </select>
                            {validationErrors.selectedSub && <div className="invalid-feedback">{validationErrors.selectedSub}</div>}
                        </div>
                    </div>

                    {/* Bank and Branch  */}
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label>Bank<span style={{ color: 'red' }}>*</span></label>
                            <select className={`form-control ${validationErrors.selectedBank ? "is-invalid" : ""}`} value={selectedBank} onChange={handleMultiSelectChange}>
                                <option value="">Select Bank</option>
                                {banks.map((item, index) => (
                                    <option key={index} value={item.id}>
                                        {item.bankName}
                                    </option>
                                ))}
                            </select>
                            {validationErrors.selectedBank && <div className="invalid-feedback">{validationErrors.selectedBank}</div>}
                        </div>
                        <div className="col-md-6">
                            <label>Branches<span style={{ color: 'red' }}>*</span></label>
                            <select className={`form-control ${validationErrors.branchvalue ? "is-invalid" : ""}`}
                                disabled={!selectedBank}
                                value={branchvalue}
                                onChange={handlebranceChange}>
                                <option value="">Select Branch</option>
                                {branch.map((item, index) => (
                                    <option key={index} value={item.id}>
                                        {item.branchName}
                                    </option>
                                ))}
                            </select>
                            {validationErrors.branchvalue && <div className="invalid-feedback">{validationErrors.branchvalue}</div>}
                        </div>
                    </div>

                    {/* cancel and submit buttons */}
                    <div className="d-flex justify-content-end align-items-center mt-3" style={{ gap: '10px' }}>
                        <button
                            className="btn"
                            style={{
                                backgroundColor: '#FF474C',
                                color: 'white',
                                height: '35px',
                                padding: '0 16px',
                                border: 'none',
                                borderRadius: '6px',
                                fontFamily: 'Poppins',
                                fontSize: '13px'
                            }}
                            onClick={handleClose}
                        >
                            Cancel
                        </button>

                        <button
                            className="btn"
                            style={{
                                backgroundColor: '#1a7a73',
                                color: 'white',
                                height: '35px',
                                padding: '0 16px',
                                border: 'none',
                                borderRadius: '6px',
                                fontFamily: 'Poppins',
                                fontSize: '13px'
                            }}
                            onClick={handleSubmit}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AlertModal;